import React from 'react'
import parser from 'html-react-parser';
import Accordion from 'react-bootstrap/Accordion';

export default function Topics({data}) {
    const {topicsTitle, topicsBlocks} = data;
    return (
        <section className='ourworkfaq-wrap dana-faq-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='co-md-12 text-center'>
                        <h2 className='heading-level-2 blue-color'>{topicsTitle && parser(topicsTitle)}</h2>
                    </div>
                    <div className='co-md-12'>
                        <Accordion>
                            {topicsBlocks.map((block, i) => (
                                <Accordion.Item eventKey={i} key={i}>
                                    <Accordion.Header>
                                        {block.topicsBlockHeader && parser(block.topicsBlockHeader)}
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>{block.topicsBlockBody && parser(block.topicsBlockBody)}</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    )
}
